import { Box, Button } from "@mui/material";

import { TestIds } from "@storyboard/web-test-ids/testIds";

/**
 * Confirms a sent fleet message and counts the drivers it reached.
 */
export default function FleetMessageSuccess({
  temporaryChannels,
  setShowSuccessMessage,
}: {
  temporaryChannels: string[];
  setShowSuccessMessage: (value: boolean) => void;
}) {
  return (
    <Box
      data-sb={TestIds.fleet.success}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box sx={{ width: "450px" }}>
        <Box sx={{ mb: 2, fontWeight: "bold", fontSize: 18 }}>
          Fleet Message sent to {temporaryChannels?.length} recipients successfully!
        </Box>
        <Box sx={{ textAlign: "center" }}>
          <Button onClick={() => setShowSuccessMessage(false)} variant="outlined">
            Dismiss
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
